import React from 'react';
import { Helmet } from 'react-helmet';

/** CASSIOPEIA */
import ThemeContext from '@thesoutherncross-uk/cassiopeia/dist/context/theme';
import { isBreakpoint } from '@thesoutherncross-uk/cassiopeia/dist/utilities';
import {
  VisibleOn,
  HiddenOn,
} from '@thesoutherncross-uk/cassiopeia/dist/components';

/** COMPONENTS */
import Page from '../../components/page';
import SocialLogos from '../../components/social-logos';

import {
  Card,
  CardContent,
  CardMedia,
  Heading,
  CreatedBy,
  Footer,
} from './coming-soon.styled';

/**
 * Coming Soon Page
 * Temporary page to be displayed until site is ready
 *
 * @returns
 */
const ComingSoon = () => {
  const theme = React.useContext(ThemeContext);
  const [isMobile, setIsMobile] = React.useState(
    isBreakpoint('xs', 'sm', 'md'),
  );

  /** COMPONENTS */
  const Author = ({ color }) => (
    <CreatedBy>
      {'Created by '}
      <span style={{ color: color, fontWeight: 700 }}>Mark Bailey</span>
    </CreatedBy>
  );

  /** ONMOUNT USEEFFECT */
  React.useEffect(() => {
    const updateIsMobile = () => setIsMobile(isBreakpoint('xs', 'sm', 'md'));
    updateIsMobile();

    window.addEventListener('resize', updateIsMobile);
    return () => window.removeEventListener('resize', updateIsMobile);
  }, []);

  return (
    <>
      <Helmet>
        <title>Coming Soon</title>
      </Helmet>

      <Page
        primary={!isMobile}
        centered={!isMobile}
        style={{ display: 'flex', flexDirection: 'column' }}
      >
        <Card theme={theme}>
          <CardMedia theme={theme}>
            <HiddenOn xs sm>
              <Author color={theme.palette.secondary} />
            </HiddenOn>
          </CardMedia>

          <CardContent theme={theme}>
            <h5
              style={{
                textTransform: 'uppercase',
                fontSize: 18,
              }}
            >
              {'The Southern '}
              <span style={{ color: theme.palette.secondary }}>Cross</span>
              {' UK'}
            </h5>

            <div style={{ paddingTop: 16 }}>
              <Heading theme={theme}>
                {'Coming '}
                <span style={{ color: theme.palette.secondary }}>Soon</span>
              </Heading>
              <p>
                We are a friendly group of like-minded gamers. We play many
                multiplayer, as well as a bunch of single player games, while we
                chat to each other. Our group has been around for over 10 years.
              </p>

              <p>
                We host a variety of games on our server, all we ask is you
                follow our rules (no griefing, no stealing, play friendly, and
                listen to the admins).
              </p>

              <span>Hope to see you in our games.</span>
            </div>

            <HiddenOn xs sm md>
              <SocialLogos align="center" dark style={{ marginTop: 32 }} />
            </HiddenOn>
          </CardContent>
        </Card>

        <VisibleOn xs sm md>
          <Footer theme={theme}>
            <SocialLogos
              align="center"
              // size={32}
              iconOnly
              style={{ marginBottom: 10 }}
            />
            <Author color={theme.palette.buttermilk} />
          </Footer>
        </VisibleOn>
      </Page>
    </>
  );
};

export default ComingSoon;
